var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"additional-info"},[_c('EsyImg',{attrs:{"src":require(`~/assets/images/logos/${_vm.icon}.svg`),"alt":_vm.altText,"width":_vm.width,"height":_vm.height}}),_vm._v(" "),_c('p',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }